import { OperationVariables, TypedDocumentNode } from '@apollo/client';
import { useGraphQLQuery } from '@betterment/graphql';
import { ErrorBoundary } from '@betterment/shared-components';

type GQLQuery<TData, TVariables extends OperationVariables> = {
  query: TypedDocumentNode<TData, TVariables>;
  variables: TVariables;
  uniqueKey: string;
};

const PrefetchFragment = <TData, TVariables extends OperationVariables>({
  query,
  variables,
}: GQLQuery<TData, TVariables>) => {
  useGraphQLQuery(query, {
    variables,
    throwOnError: true,
  });

  return null;
};

type PrefetchProps<TData, TVariables extends OperationVariables> = {
  queries: GQLQuery<TData, TVariables>[];
};

export const Prefetch = <TData, TVariables extends OperationVariables>({
  queries,
  children,
}: React.PropsWithChildren<PrefetchProps<TData, TVariables>>) => {
  return (
    <>
      <ErrorBoundary fallbackType="none">
        {queries.map(query => {
          return <PrefetchFragment key={query.uniqueKey} {...query} />;
        })}
      </ErrorBoundary>
      {children}
    </>
  );
};
